/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function EmptyCartRecommendations
 */
class EmptyCartRecommendations extends HTMLElement {
	constructor() {
		super();
	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const section = html.querySelector('.shopify-section');

				if (section && section.innerHTML.trim().length) {
					this.innerHTML = section.innerHTML;
					const track = this.closest('.cart-drawer__empty-recommendations--products');
					if (track && !track.dataset.dragInit) {
						track.dataset.dragInit = '1';
						initEmptyCartCarouselDrag(track);
					}
				}

				this.classList.add('empty-cart-recommendations--loaded');
			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('empty-cart-recommendations', EmptyCartRecommendations);

function initEmptyCartCarouselDrag(track) {
	let startX = 0;
	let scrollLeft = 0;
	let isDragging = false;
	let hasMoved = false;

	function onDragStart(x) {
		isDragging = true;
		hasMoved = false;
		startX = x - track.offsetLeft;
		scrollLeft = track.scrollLeft;
		track.classList.add('is-dragging');
	}

	function onDragMove(x) {
		if (!isDragging) return;
		const dx = x - track.offsetLeft - startX;
		if (Math.abs(dx) > 4) hasMoved = true;
		track.scrollLeft = scrollLeft - dx;
	}

	function onDragEnd() {
		isDragging = false;
		track.classList.remove('is-dragging');
	}

	// Mouse-only drag — mobile uses native overflow scrolling
	track.addEventListener('mousedown', (e) => {
		onDragStart(e.pageX);
		e.preventDefault();
	});
	window.addEventListener('mousemove', (e) => {
		if (isDragging) onDragMove(e.pageX);
	});
	window.addEventListener('mouseup', () => {
		onDragEnd();
	});

	// Suppress click on links only after a mouse drag
	track.addEventListener('click', (e) => {
		if (hasMoved) e.preventDefault();
	}, true);
}

function initEmptyCartCarousels() {
	// Only attach JS drag on devices with a fine pointer (mouse/trackpad).
	// Touch devices use native overflow scrolling instead.
	if (!window.matchMedia('(pointer: fine)').matches) return;
	document.querySelectorAll('.cart-drawer__empty-recommendations--products').forEach((track) => {
		if (!track.dataset.dragInit) {
			track.dataset.dragInit = '1';
			initEmptyCartCarouselDrag(track);
		}
	});
}
document.addEventListener('DOMContentLoaded', initEmptyCartCarousels);
document.addEventListener('cart-drawer:open', initEmptyCartCarousels);
